import { useDispatch, useSelector } from 'react-redux'
import { CardHead } from '../ui'
import { UserList } from './index'
import { useEffect, useState } from 'react'
import { detailOpen } from '../../store/openModal/OpenDetailSlices'
import { modalOpen } from '../../store/openModal/OpenModalSlices'
import { GroupGeren } from './GroupGeren'
import { CondDePago } from './CondDePago'
import { GerenciasAdmin } from './GerenciasAdmin'
import { ComerciosAdmin } from './ComerciosAdmin'


export const Administracion = () => {

 
  const permisos = ["Vendedor", "Gerencia", "Direccion", "Administracion", "Sysadmin"]
  const userData = useSelector((state) => state.user)
  const canViewGerencias = userData.Permiso === 'Direccion'
  const canManageCommerces = ['Direccion', 'Sysadmin', 'Administracion'].includes(userData.Permiso)
  const [subSect, setSubSect] = useState('lista')
  const [subSection, setSubSection] = useState('')
  const [modUser, setModUser] = useState({})
  const dispatch = useDispatch()
  
  const handleSubSection = (e) => {
      const nextSubSect = e.target.value
      if (nextSubSect === 'gerencias' && !canViewGerencias) return
      setSubSect(nextSubSect)
  }

  useEffect(() => {
    if (subSect === 'gerencias' && !canViewGerencias) {
      setSubSect('lista')
    }
  }, [subSect, canViewGerencias])
  
  const handleModalUser = (bool, sect, u = {}) => {
      setSubSection(sect)
      setModUser(u)
      dispatch(modalOpen({ a: bool }))
  }

  const hadleDetail = (id, e) => {
    e.preventDefault()

    dispatch(detailOpen(id))
  }

 //console.log(subSect)
  return (
      <>  
     <div className="card">
       <CardHead section='Administracion' />
      
    
            <div className="adminTabs d-flex p-2">
                    {
                        ['Administracion', 'Sysadmin', 'Direccion'].includes(userData.Permiso)
                        &&
                        <>
                            <button
                                className={`p-2 btn checkBtn text-uppercase ${subSect === 'lista' ? 'checkedBtn' : ''}`}
                                value='lista'
                                onClick={handleSubSection}
                            >
                                Lista de Usuarios
                            </button>

                        </>
                    }
                    {
                        ['Administracion', 'Sysadmin', 'Direccion','Gerencia'].includes(userData.Permiso)
                        && 
                        <button 
                            className={`p-2 btn checkBtn text-uppercase ${subSect === 'gerencia' ? 'checkedBtn' : ''}`}
                            value='gerencia'
                            onClick={handleSubSection}
                            >
                              Asignacion de Clientes
                        </button>
                    }
                    {
                        canViewGerencias
                        &&
                        <button
                            className={`p-2 btn checkBtn text-uppercase ${subSect === 'gerencias' ? 'checkedBtn' : ''}`}
                            value='gerencias'
                            onClick={handleSubSection}
                        >
                            Gerencias
                        </button>
                    }
                    {
                        ['Administracion', 'Sysadmin', 'Direccion'].includes(userData.Permiso)
                        &&
                        <button
                            className={`p-2 btn checkBtn text-uppercase ${subSect === 'pago' ? 'checkedBtn' : ''}`}
                            value='pago'
                            onClick={handleSubSection}>
                            Cond. de Pago
                        </button>
                    }
                    {
                        canManageCommerces
                        &&
                        <button
                            className={`p-2 btn checkBtn text-uppercase ${subSect === 'comercios' ? 'checkedBtn' : ''}`}
                            value='comercios'
                            onClick={handleSubSection}>
                            Comercios
                        </button>
                    }
                
              
            </div>  {
      subSect === 'lista'
                ? <UserList subSection={subSection} permisos={permisos}  hadleDetail={hadleDetail}  handleModalUser={handleModalUser} modUser={modUser} />  
                :  subSect === 'gerencia'
                    ? <GroupGeren />
                    : subSect === 'gerencias'
                        ? (canViewGerencias ? <GerenciasAdmin /> : <CondDePago />)
                        : subSect === 'comercios'
                            ? (canManageCommerces ? <ComerciosAdmin /> : <CondDePago />)
                        : <CondDePago/>
      }
</div>
      </>
  )
}
